import {isNumber, isString} from './typeof'

export function getTplValue(obj) {
  if (!obj) {
    return null;
  }
  return obj.mvalue[gact.invoker] || obj.mvalue.default;
}


export function processComp(obj) {
  processRem(obj);
  processCss(obj);
}

function processRem(obj) {
  for (let k in obj) {
    if (['width', 'height', 'top', 'left'].indexOf(k) !== -1) {
      obj[k] = toRem(obj[k]);
    }
  }
}


function processCss(obj) {
  const width = obj.width;
  const height = obj.height;

  const style = {};
  if (width) {
    style.width = width;
    delete obj['width']
  }
  if (height) {
    style.height = height;
    delete obj['height']
  }

  obj['css'] = style;

}


export function toRem(value) {
  if (isString(value)) {
    value = value.replace(/px$/, '');
    value = parseFloat(value);
  }

  if (isNumber(value)) {
    return value / 100 * 2 + 'rem'
  }
  return '0';
}



// WEBPACK FOOTER //
// ./src/tools/tpl.js